<template>
       <!-- Add Account Modal -->
    <div class="modal worli-Bets-Modal modal-style" id="acc-open-model" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header headerTheme">
                    <h5 class="modal-title">{{$t('add-account', 'Add Account')}}</h5>
                    <button type="button" @click="clearError()" id="closeBtn" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <div class="modal-body add_bank_acc_form">
                    <div class="p-0">
                        <div class="acc-login-form-sec" v-if="paymentMethodList">
                            <label>{{ $t('payment-method', 'Payment Method') }} <small style="color: red;">*</small></label>
                            <select @change="onPaymentMethodChange" v-model="paymentMethodId" class="form-select form-control">
                                <option value="null">---{{ $t('select-payment-method', 'Select Payment Method') }}---</option>
                                <option v-for="(item, index) in paymentMethodList" :key="index" :value="item.id" >{{ item.method_name }}</option>
                            </select>
                        </div>
                            
                        <template v-if="type === 'bank'">
                            <div class="acc-login-form-sec" v-if="filteredBankList">
                                <div class="select-payment-list">
                                    <div class="dropdown bank-dropdown">
                                        <button class="bank-dropdown-input" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                        {{  selectedBank ? selectedBank : $t('select-bank-name', 'Select Bank Name') }}
                                        </button>
                                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            <div class="search-input">
                                                <input type="search" v-model="searchBank" class="form-control" placeholder="Search Banks...">
                                            </div>
                                            <li v-for="(item, index) in filteredBankList" :key="index" v-if="filteredBankList && filteredBankList.length">
                                                <a class="dropdown-item" @click="selectBank(item)">{{ item.bank_name }}</a>
                                            </li>
                                            <li v-else>
                                                <a class="dropdown-item add-bank-no-data-show">{{$t('no-data-found','No data found')}}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <p v-if="error  && !accountForm.bankId" class="wallet-error">{{ $t('please-select-bank-name', 'Please Select Bank Name') }}.</p>
                            </div>
                            <div class="acc-login-form-sec">
                                <label>{{ $t('account-holder-name', 'Account Holder’s Name') }} <small style="color: red;">*</small></label>
                                <input type="text" v-model="accountForm.holderName" :placeholder="$t('enter-account-holder-name', 'Enter Account Holder Name')" class="form-control">
                                <div v-if="v$.accountForm.holderName?.$error && accountForm.holderName == ''" class="wallet-error" for="nameInput">
                                    {{ $t('account-holder-name-is-required', 'Account Holder Name Is Required') }}</div>
                                <div v-else-if="v$.accountForm.holderName?.$error && (v$.accountForm.holderName?.minLength.$invalid || v$.accountForm.holderName?.maxLength.$invalid)" class="wallet-error" for="nameInput">
                                    {{ $t('Account-holder-name-must-be-3-100-characters', 'Account Holder Name Must Be 3-100 Characters') }}</div>
                                <div class="wallet-error" v-if="v$.accountForm.holderName?.$error && v$.accountForm.holderName?.alphaName.$invalid">
                                    Must Contain Only Alphabets, Spaces, Dots, Or Hyphens</div>                                 
                            </div>
                            <div class="acc-login-form-sec">
                                <label>{{ $t('ac-number', 'A/C Number') }} <small style="color: red;">*</small></label>
                                <input v-model="accountForm.accountNumber" type="tel" maxlength="20" :placeholder="$t('enter-ac-Number', 'Enter A/C Number')" class="form-control">
                                
                                <div v-if="v$.accountForm.accountNumber.$error && accountForm.accountNumber == ''" class="wallet-error" for="nameInput">
                                    {{ $t('account-number-is-required', 'Account Number Is Required') }}.</div>                               
                                <div class="wallet-error" for="nameInput" v-else-if="v$.accountForm.accountNumber.$error && accountForm.accountNumber != ''">
                                    Account Number Must Be A Valid Numeric Value Between 9 to 18 Digits</div>
                            </div>
                            <div class="acc-login-form-sec">
                                <label>{{ $t('ifsc-code', 'IFSC Code') }} <small style="color: red;">*</small></label>
                                <input v-model="accountForm.ifscCode" type="text" maxlength="11" @input="accountForm.ifscCode = accountForm.ifscCode.toUpperCase()" :placeholder="$t('ifsc-code-is-required', 'IFSC Code is required')" class="form-control">
                                <div v-if="v$.accountForm.ifscCode.$error && accountForm.ifscCode == ''" id="ifscCodeInput-error" class="wallet-error" for="ifscCodeInput">
                                    {{ $t('ifsc-code is-required', 'IFSC Code is required') }}.</div>
                                <div class="wallet-error" for="nameInput" v-if="v$.accountForm.ifscCode.$error && v$.accountForm.ifscCode?.ifscValidator.$invalid">
                                    IFSC code should be 11 Alphanumeric Characters</div>
                            </div>
                        </template>
                        <template v-if="type === 'upi' || type === 'wallet'">
                            <div class="acc-login-form-sec">
                                <label>{{ $t('account-holder-name', 'Account Holder’s Name') }} <small style="color: red;">*</small></label>
                                <input v-model="accountForm.holderName"  type="text" class="form-control" :placeholder="$t('enter-account-holder-name', 'Enter Account Holder Name')"/>
                                <div v-if="v$.accountForm.holderName?.$error && accountForm.holderName == ''" class="wallet-error" for="nameInput">
                                    {{ $t('account-holder-name-is-required', 'Account Holder Name Is Required') }}</div>
                                <div v-else-if="v$.accountForm.holderName?.$error && (v$.accountForm.holderName?.minLength.$invalid || v$.accountForm.holderName?.maxLength.$invalid)" class="wallet-error" for="nameInput">{{ $t('Account-holder-name-must-be-3-100-characters', 'Account Holder Name Must Be 3-100 Characters') }}</div>
                                <div class="wallet-error" v-if="v$.accountForm.holderName?.$error && v$.accountForm.holderName?.alphaName.$invalid">
                                    Must Contain Only Alphabets, Spaces, Dots, Or Hyphens</div> 
                            </div>


                            <template v-if="type === 'upi'">
                                <div class="acc-login-form-sec">
                                    <label>{{ $t('upi-id', 'UPI ID') }}</label>
                                    <input v-model="accountForm.upiId" class="form-control profit-input" type="text" :placeholder="$t('enter-upi-id', 'Enter UPI ID')">
                                    <div v-if="accountForm.upiId != '' && v$.accountForm.upiId.$error && v$.accountForm.upiId.minLength.$invalid || v$.accountForm.upiId.maxLength.$invalid" class="wallet-error" for="nameInput">
                                        {{ $t('must-be-5-to-50-characters', 'UPI ID Must Be 5 to 50 Characters') }}</div>
                                    <div class="wallet-error" v-if="accountForm.upiId != '' && v$.accountForm.upiId.$error && v$.accountForm.upiId.upiValidator.$invalid">
                                        Must Be In The Format Of 'name@bank'</div>
                                </div>
                            </template>

                            <template v-if="type === 'wallet'">
                                <div class="acc-login-form-sec">
                                    <label>{{ $t('wallet-id', 'Wallet ID') }} <small style="color: red;">*</small></label>
                                    <input v-model="accountForm.walletId" class="form-control profit-input" type="text" :placeholder="$t('enter-wallet-id', 'Enter wallet ID')">
                                    <div class="wallet-error" v-if="v$.accountForm.walletId.$error && accountForm.walletId == ''">
                                        {{ $t('wallet-id-is-required', 'Wallet ID is required') }}</div>
                                    <div v-else-if="v$.accountForm.walletId.$error && v$.accountForm.walletId.minLength.$invalid || v$.accountForm.walletId.maxLength.$invalid" class="wallet-error" for="nameInput">
                                        {{ $t('must-be-8-20-characters-long', 'Wallet ID Must Be 8-20 Characters Long') }}</div>
                                    <div class="wallet-error" v-if="v$.accountForm.walletId.$error && v$.accountForm.walletId.walletValidator.$invalid">
                                        Must Contain Only Letters, Numbers, @, Hyphens, Or Underscores</div> 
                                </div>
                            </template>

                            <div class="acc-login-form-sec">
                                <label v-if="!accountForm.file" class=" info-sec">{{ $t('qr-code-upload-screenshot', 'QR Code (Upload Screenshot)') }} 
                                    <!-- <span v-if="file == null">[{{ $t('required', 'Required') }}]</span> -->
                                    <span class="info-sec-icon upload-qr-code-tooltips">
                                        <img src="@/assets/images/info-icon.svg" alt="info-icon" loading="lazy">
                                        <div class="info-tooltip">
                                            <ul>
                                                <li>1. {{ $t('tap-your-profile', 'Upload a screenshot of a valid QR code to proceed') }}.</li>
                                                <li>2. {{ $t('tap-qr-code', 'If QR code is not detected, Exchange will not be responsible for the losses') }}.</li>
                                            </ul>
                                        </div>
                                    </span>
                                </label>
                                <div class="file-upload-sec" v-if="!previewImg">
                                    <label for="file"  class="file-upload">
                                        <span><img src="@/assets/images/file-icon.svg" alt="file-icon" loading="lazy"></span>
                                        <h6>{{ $t('file-upload', 'File Upload') }}</h6>
                                    </label>
                                    <input class="form-control profit-input d-none" ref="fileInput" type="file" accept=".png,.jpg,.jpeg,.webp" id="file" @change="fileUpdateFunc">
                                </div>
                                <div class="uploadFile-wrap" v-if="previewImg">
                                    <h5 class="uploadFile-title-wrap">{{$t('qr-code', 'QR Code')}}</h5>
                                    <div class="fileList">
                                        <img class="fileList-img" :src="previewImg"  alt="file" loading="lazy"/>
                                        <button class="add-utr-again" @click="removeFile">&#10006;</button>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template  v-if="type">
                           <div class="acc-login-form-sec">
                            <label for="nameInput">{{ $t('withdrawal-password', 'Withdrawal Password') }} <small style="color: red;">*</small></label>
                               <div class="fill_con">
                                   <input :type="passwordFieldType"  v-model="accountForm.withdrawal_password" @input="accountForm.withdrawal_password = $helper.sanitizeDetails('withdrawPassword', accountForm.withdrawal_password, 20)"  
                                   :placeholder="$t('enter-withdrawal-password', 'Enter Withdrawal Password')" class="form-control password-input" />
                                   <!-- <div class="score-hide-show" @click="togglePasswordVisibility('passwordField')">
                                       <img  rel="preload" v-if="passwordFieldType === 'password'" src="@/assets/images/eye-close.png">
                                       <img  rel="preload" v-else src="@/assets/images/eye-open.webp" alt="">
                                   </div> -->
                                    <div class="showHide-pass">
                                        <i @click="togglePasswordVisibility('passwordField')" class="fa-solid" :class="passwordFieldType === 'password' ? 'fa-eye-slash' : 'fa-eye'"></i>
                                    </div>
                               </div>
                                <div v-if="v$.accountForm.withdrawal_password.$error" class="wallet-error" for="nameInput">
                                    {{ $t('please-enter-withdraw-password', 'Please Enter Withdraw Password') }}</div>
                           </div>
                       </template>
                    </div>
                    <div class="header-but info-footer">
                        <button type="button" class="thm-but thm-bor-but" data-bs-dismiss="modal" @click="clearError()">{{$t('cancel','Cancel')}}</button>
                        <a class="thm-but" @click="addAccountServiceCall()">{{$t('save','Save')}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required, minLength, maxLength, helpers } from '@vuelidate/validators';
import {addAccount} from '../services/withdrawAccountDetails';
const alphaName = helpers.withMessage(
  'Must contain only alphabets, spaces, dots, or hyphens.',
  (value) => {
    if (value === null || value === undefined || value === '') return true
    const s = String(value)
    return /^[A-Za-z .-]+$/.test(s)
  }
)
const ifscValidator = helpers.withMessage(
  "Invalid IFSC Code format. It should be 11 alphanumeric characters like 'SBIN0001234'.",
  (value) => {
    if (!value) return true
    return /^[a-zA-Z0-9]{11}$/.test(String(value))
  }
)
const upiValidator = helpers.withMessage(
  "Must be in the format of 'name@bank.'",
  (value) => {
    if (!value) return true
    return /^[A-Za-z0-9]+@[A-Za-z0-9]+$/.test(String(value))
  }
)
const walletValidator = helpers.withMessage(
  'Must contain only letters, numbers, @, hyphens, or underscores.',
  (value) => {
    if (value === null || value === undefined || value === '') return true
    return /^[A-Za-z0-9@_-]+$/.test(String(value))
  }
)
export default {
    name: 'AddBankAccount',
    setup() {
		return { v$: useVuelidate() }
	},
    emits:['getAccountDetailList','open-withdraw-password-modal'],
    inject:['onlyBank','walletConfig'],
    data() {
        return {
            loading: false,
            paymentMethodId: null,
            type: null,
            bankDetailsList: null,
            paymentMethodList: null,
            error:false,
            accountForm: {
				bankId: null,
				holderName: '',
				accountNumber: '',
				ifscCode: '',
				upiId: '',
				walletId: '',
				file: null,
                withdrawal_password: null
			},
            passwordFieldType: 'password',
            searchBank:null,
            selectedBank:null,
            onlyBankStatus: false,
            previewImg:null,
            paymentMethod: null
        }
    },
    computed: {
        filteredBankList() {            
            if(this.searchBank) {
                const searchTermLower = this.searchBank?.toLowerCase();
                return this.bankDetailsList.filter(item => item.bank_name?.toLowerCase().includes(searchTermLower));
            }
            return this.bankDetailsList
        }
    },
    validations() {
        return {
            accountForm: {
                bankId: this.type === 'bank' ? { required } : {},
                holderName: { required, minLength: minLength(3),
                    maxLength: maxLength(100),
                    alphaName },
                accountNumber: this.type === 'bank' ? { 
                    required, 
                    minLength: minLength(9),
                    maxLength: maxLength(18) } : {},
                ifscCode: this.type === 'bank' ? { required, ifscValidator } : {},
                upiId: this.type === 'upi' ? { 
                    minLength: minLength( 5 ),
                    maxLength: maxLength( 50 ),
                    upiValidator  } : {},
                walletId: this.type === 'wallet' ? { 
                    required,
                    minLength: minLength( 8),
                    maxLength: maxLength( 20),
                    walletValidator } : {},
                withdrawal_password: { required },

            }
        };
    },
    mounted(){
        this.bankDetailsList = this.walletConfig?.bank_list
        this.paymentMethodList = this.walletConfig?.payment_method
    },
    methods: {
        removeFile() {
            this.accountForm.file = null;
            this.previewImg = null;
        },
        selectBank(item){
            this.accountForm.bankId = item.id
            this.selectedBank = item.bank_name
            this.searchBank = ''
        },
        clearSearch() {
            this.searchBank = ''; 
        },
        onPaymentMethodChange() {
            this.clearData();
            const selectedItem = this.paymentMethodList.find(item => item.id === this.paymentMethodId);
            this.paymentMethod = selectedItem
            this.getPaymentMethodItem(selectedItem);
        },
        clearData(){
            this.accountForm = {
				bankId: null,
				holderName: '',
				accountNumber: '',
				ifscCode: '',
				upiId: '',
				walletId: '',
				file: null,
                withdrawal_password: null
			}
            this.errors = {};
            this.error = false
            this.selectedBank = null;
            this.searchBank=null,
            this.v$.$reset();
            this.previewImg = null;
        },
        getPaymentMethodItem(item) {
            this.type = item?.method_type;
            this.accountForm.paymentMethodId = item.id;
		    this.accountForm.paymentTypeName = item.name;
        },
        async addAccountServiceCall() { 
             this.v$.$touch()
            if (this.v$.$error) {
                return
            } else {
                if(this.type === 'upi' && this.accountForm.upiId == '' && this.accountForm.file == null){
                    this.$errorToast('At least one field is required UPI ID or QR code.')
                    return false;
                }
                let response = await addAccount(this.paymentMethod, this.type, this.accountForm, null)
                if(response){
                    this.v$.$reset();  
                    this.$helper.closeModal('acc-open-model')
                    this.$emit('getAccountDetailList');
                    this.clearError();
                    this.$successToast(response?.data?.message);
                }
            }
        },

        fileUpdateFunc(event) {
            this.accountForm.file = event.target.files[0];
            if (!this.accountForm.file.type.startsWith('image/')) {
                event.target.value = "";
                this.accountForm.file = null;
                this.$errorToast('Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB');
                return;
            }
            const maxFileSize = 5 * 1024 * 1024; 
            if (this.accountForm.file.size > maxFileSize) {
                this.accountForm.file = null;
                this.$errorToast(`Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB`)
                return
            }  
            this.previewImg = URL.createObjectURL(this.accountForm.file);
        },
        clearError() {
            this.accountForm = {
				bankId: null,
				holderName: '',
				accountNumber: '',
				ifscCode: '',
				upiId: '',
				walletId: '',
				file: null
			},
            this.type = null,
            this.paymentMethodId = null,
            this.errors = {};
            this.selectedBank = null;
            this.searchBank=null,
            this.v$.$reset();
        },
        
        togglePasswordVisibility() {
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
        }
    }
}
</script>